module.exports = __webpack_public_path__ + "img/kf1.afcbc86c.png";